<template>
    <PopupRouterView :showLeftIcon="true" label="Picking Supply For Subcontract Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="pickingsupplyforsubcontract"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="pickingSupplyForSubcontractInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-work-order-supply-subcontract" ref="fieldset-work-order-supply-subcontract" :model.sync="workOrderSupplySubcontractQrCode" label="Work Order Supply (W/O No)" @scannedMethod="scanWorkOrderSupplySubcontract" :isBusy="isScanWorkOrderSupplySubcontractLoading" autofocus />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="PickingSupplyForSubcontracts != null && PickingSupplyForSubcontracts.length > 0">
							<app-list :isDataLoading="isWorkOrderSupplySubcontractPickingSupplyForSubcontractsLoading" :dataCount="PickingSupplyForSubcontracts.length">
								<work-order-supply-sub-contract-parent v-for="(item,index) in PickingSupplyForSubcontracts" :model="item" :key="index" @nextAction="goToNextFromScanWos(2, item)" :isDisabled="checkIsWorkOrderSupplySubContractDisabled(item)"/>
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" type="text" label="Work Order Supply (W/O No)" :model="model.workOrderSupplySubcontract!=null && model.workOrderSupplySubcontract!=undefined ? model.workOrderSupplySubcontract.materialIssueNumber : ''" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-input-scan id="fieldset-work-order-supply-subcontract-part" ref="fieldset-work-order-supply-subcontract-part" :model.sync="workOrderSupplySubcontractPartQrCode" label="Material Issue Part" @scannedMethod="scanWorkOrderSupplyPartSubcontract" :isBusy="isScanWorkOrderSupplySubcontractPartLoading" autofocus />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="pickingSupplyForSubcontractDetails != null && pickingSupplyForSubcontractDetails.length > 0">
							<app-list :isDataLoading="isPickingSupplyForSubcontractDetailsLoading" :dataCount="pickingSupplyForSubcontractDetails.length">
								<work-order-supply-sub-contract-item v-for="(item,index) in pickingSupplyForSubcontractDetails" :model="item" :key="index" @nextAction="goToNextFromScanPart(3, item)" :isDisabled="checkIsWorkOrderSupplySubContractDisabled(item)"/>
							</app-list>
						</span>
					</b-col>
				</b-row>
				<!-- <b-row>
					<b-col cols="12">
						<span v-if="workOrderSupplySubContractsFiltered != null && workOrderSupplySubContractsFiltered.length > 0">
							<app-table-input
								title="Work Order Supply Sub Contract"
								:bordered="true"
								:items="workOrderSupplySubContractsFiltered"
								:fields="fieldsWorkOrderSupplySubContract"
								:busy="isDataLoading"
								:sort-by.sync="sortByWorkOrderSupplySubContract"
								:sort-desc.sync="sortDescWorkOrderSupplySubContract" small responsive
								:showActionButton="false"
								:showDeleteButton="false"
								:showAddButton="false"
								:showAddFromClipboardButton="false"
								:showReplaceFromClipboardButton="false"
								:showUploadButton="false"
								:showDownloadButton="false"
								:isDownloadBusy="isDownloadWorkOrderSupplySubContract"
							/>
						</span>

					</b-col>
				</b-row> -->
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" type="text" label="Work Order Supply (W/O No)" :model="model.workOrderSupplySubcontract!=null && model.workOrderSupplySubcontract!=undefined ? model.workOrderSupplySubcontract.materialIssueNumber : ''" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="Material Part Number" :model="modelDetail.part!=null && modelDetail.part!=undefined ? modelDetail.part.partNumber : ''" />
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="FG Part Number" :model="modelDetail.workOrderSupplyForSubconDetail!=null && modelDetail.workOrderSupplyForSubconDetail!=undefined && modelDetail.workOrderSupplyForSubconDetail.part!=null && modelDetail.workOrderSupplyForSubconDetail.part!=undefined ? modelDetail.workOrderSupplyForSubconDetail.part.partNumber : ''" />
					</b-col>
				</b-row>

				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="Material Part Name" :model="modelDetail.part!=null && modelDetail.part!=undefined ? modelDetail.part.partName : ''" />
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="FG Part Name" :model="modelDetail.workOrderSupplyForSubconDetail!=null && modelDetail.workOrderSupplyForSubconDetail!=undefined && modelDetail.workOrderSupplyForSubconDetail.part!=null && modelDetail.workOrderSupplyForSubconDetail.part!=undefined ? modelDetail.workOrderSupplyForSubconDetail.part.partName : ''" />
					</b-col>
				</b-row>
				
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="Supply Qty" :model="modelDetail.supplyQty" />
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="Remaining Qty" :model="modelDetail.remainingQty" />
					</b-col>
				</b-row>
				
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-control-card" ref="fieldset-control-card" :model.sync="controlCardQrCode" label="Control Card" :isDisabled="!enableInputControlCard" @scannedMethod="scanControlCard" :isBusy="isScanControlCardLoading" autofocus />
					</b-col>
					<b-col cols="12">
						<app-input-textbox id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="remarkInput" :isUpdateable="enableInputControlCard" :isEditable="enableInputControlCard" />
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 1 && false" size="sm" class="btn-fill-success float-right" @click="finishScan()">Finish</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="goToNext(1)">Back</b-button>
			<b-button v-if="scanPageIndex == 2 && false" size="sm" class="btn-fill-success float-right" @click="finishScan()">Finish</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="goToNext(2)">Back</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="finishScan()">Finish</b-button>
        </template>
		<PickingSupplyForSubcontractDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelPickingSupplyForSubcontractDetail"
			:modelId="pickingSupplyForSubcontractDetailId"
			:openPopup="isShowPopupPickingSupplyForSubcontractDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataPickingSupplyForSubcontractDetail"/>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
import PickingSupplyForSubcontractScanner from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractScanner';
import PickingSupplyForSubcontractList from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractList';
import PickingSupplyForSubcontractFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractFilter';
import WorkOrderSupplySubContractItem from './components/WorkOrderSupplySubContractItem';
import WorkOrderSupplySubContractParent from './components/WorkOrderSupplySubContractParent';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PickingSupplyForSubcontractDetail from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetail';
import PickingSupplyForSubcontractDetailFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailFilter';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingSupplyForSubcontractDetailInput from '@/views/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailInput';
import PickingSupplyForSubcontractDetailScan from '@/views/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailScan';
import PickingSupplyForSubcontractDetailUpload from '@/views/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputCheckbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		PickingSupplyForSubcontractDetailInput,
		PickingSupplyForSubcontractDetailScan,
		PickingSupplyForSubcontractDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		WorkOrderSupplySubContractItem,
		WorkOrderSupplySubContractParent,
		
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingSupplyForSubcontractDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"workOrderSupplyForSubconDetail": { "class" : "th-work-order-supply-for-subcon-detail first-child", "label" : "Work Order Supply For Subcon Detail", key: 'workOrderSupplyForSubconDetail.part', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"supplyQty": { "class" : "th-supply-qty last-child", "label" : "Supply Qty", key: 'supplyQty', sortable: false}}, 
				{"actualQty": { "class" : "th-actual-qty d-stack-none", "label" : "Actual Qty", key: 'actualQty', sortable: false}}, 
				{"isCompleted": { "class" : "th-is-completed d-stack-none", "label" : "Is Complete", key: 'isCompleted', sortable: false}}, 
				{"processBy": { "class" : "th-process-by d-stack-none", "label" : "Process By", key: 'processBy.firstName', sortable: false}}, 
				{"processDate": { "class" : "th-process-date d-stack-none", "label" : "Process Date", key: 'processDate', sortable: false}}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			PickingSupplyForSubcontractScannerObject : {},
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPickingSupplyForSubcontractDetail : {},
			isShowPopupPickingSupplyForSubcontractDetail : false,
			isShowPopupUploadPickingSupplyForSubcontractDetail : false,
			isShowPopupPickingSupplyForSubcontractDetailScan : false,
			filterPickingSupplyForSubcontract : null,
			currentPickingSupplyForSubcontractPage : 1,
			pickingSupplyForSubcontractPageSize: 10,
			sortByPickingSupplyForSubcontract: '',
			sortDescPickingSupplyForSubcontract: '',
			filterPickingSupplyForSubcontractDetail : null,
			currentPickingSupplyForSubcontractDetailPage : 1,
			pickingSupplyForSubcontractDetailPageSize: 10,
			sortByPickingSupplyForSubcontractDetail: '',
			sortDescPickingSupplyForSubcontractDetail: '',
			sortingByPickingSupplyForSubcontractDetail: [],
			pickingSupplyForSubcontractDetailId : '',
			totalPickingSupplyForSubcontractDetailRow : 0,
			isShowPickingSupplyForSubcontractDetailFilter: false,
			isDownloadPickingSupplyForSubcontractDetail: false,
			workOrderSupplySubContractDetails: [],
			parts: [],
			userInfos: [],
			workOrderSupplySubContracts: [],
			workOrderSupplySubcontracts: [],
			isWorkOrderSupplySubcontractComboLoading: false,
			documentStatuss: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderSupplySubContractComboLoading: false,
			isDocumentStatusComboLoading: false,
			isPickingSupplyForSubcontractComboLoading: false,
			isWorkOrderSupplySubContractDetailComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',

			workOrderSupplySubcontractQrCode: '',
			workOrderSupplySubcontractPartQrCode: '',
			controlCardQrCode: '',
			isScanWorkOrderSupplySubcontractLoading: false,
			isWorkOrderSupplySubcontractWorkOrderSupplySubContractsLoading: false,
			workOrderSupplySubcontractWorkOrderSupplySubContracts: [],
			workOrderSupplySubContractsFiltered: [],
			
			pickingSupplyForSubcontractDetails : [],

			isScanControlCardLoading:false,
			isScanWorkOrderSupplySubcontractPartLoading:false,
			isPickingSupplyForSubcontractDetailsLoading:false,
			PickingSupplyForSubcontracts:[],
			isWorkOrderSupplySubcontractPickingSupplyForSubcontractsLoading:false,
			isPickingSupplyForSubcontractDetailLoading:false,
			modelDetail:false,
			remarkInput:'',
			enableInputControlCard:true,
		}
	},
	methods : {
		goToNextFromScanWos(page,item){
			if (item==null || item==undefined || item.workOrderSupplySubcontract==null || item.workOrderSupplySubcontract==undefined) {
				return;
			}
			this.workOrderSupplySubcontractQrCode = item.workOrderSupplySubcontract.materialIssueNumber;
			// console.log('this.inputQrCodeDiNumber',this.inputQrCodeDiNumber)
			this.scanWorkOrderSupplySubcontract();
		},
		goToNextFromScanPart(page,item){
			if (item==null || item==undefined || item.part==null || item.part==undefined) {
				return;
			}
			this.workOrderSupplySubcontractPartQrCode = item.part.partNumber;
			this.scanWorkOrderSupplyPartSubcontract();
		},
		getPickingSupplyForSubcontracts : async function(input) {
			this.isBusy = true;
			let filter = {};
			Object.assign(filter, this.filterPickingSupplyForSubcontract);

			if (input != undefined) {
				filter.workOrderSupplyNumber = input;
			}
			filter.documentStatusId = ['OPEN', 'IN_PROGRESS'];
			// filter.documentStatusId.push('OPEN');
			// filter.documentStatusId.push('IN_PROGRESS');
			let sorting = [];
			sorting["createddate"]=0
			this.isWorkOrderSupplySubcontractPickingSupplyForSubcontractsLoading = true;

			PickingSupplyForSubcontract.getList(this, filter,sorting,0,10).then(result => {
				this.PickingSupplyForSubcontracts = result.data;
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
			
			this.isWorkOrderSupplySubcontractPickingSupplyForSubcontractsLoading = false;
		},
		// getPickingSupplyForSubcontract : async function(id) {
		// 	this.isBusy = true;
		// 	PickingSupplyForSubcontract.getData(this, id).then(result => {
		// 		this.model = result;
		// 		this.mainRecordId = String(result.mainRecordId);
		// 		let promises = Array();
    //
		// 		Promise.all(promises).then((results) => {
		// 			this.isBusy = false;
		// 		});
		// 	}).catch(error => { this.isBusy = false; });
		// },
		getPickingSupplyForSubcontractDetail : async function(id) {
			this.isBusy = true;
			PickingSupplyForSubcontractDetail.getData(this, id).then(result => {
				this.modelDetail = result;
				let promises = Array();
				this.remarkInput = this.modelDetail.remarks;
				
				if(this.modelDetail.remainingQty!=undefined && this.modelDetail.remainingQty!=null && this.modelDetail.remainingQty>0){
					this.enableInputControlCard = true;
				}else{
					this.enableInputControlCard = false;
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPickingSupplyForSubcontract = true;
			this.filterPickingSupplyForSubcontract.id = this.modelId;
			PickingSupplyForSubcontract.downloadDataDetail(this, this.filterPickingSupplyForSubcontract).then(result => {
				this.isDownloadPickingSupplyForSubcontract = false;
			}).catch(error => { this.isDownloadPickingSupplyForSubcontract = false; })
		},
		getPickingSupplyForSubcontractDetails : async function(input) {
			let filter = {};
			let this_ = this;
			Object.assign(filter, this.filterPickingSupplyForSubcontractDetail);
			if (this.modelId == null) return;

			let needSearch = false;
			
			if (this.PickingSupplyForSubcontractScannerObject!=null && this.PickingSupplyForSubcontractScannerObject!=undefined && this.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractId) {
				needSearch = true;
			}
			if (input != undefined) {
				filter.partNumber = input;
			}
			filter.pickingSupplyForSubcontractId = this.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractId;
			filter.showIsCompleteType = "false";

			if (needSearch) {
				this.isPickingSupplyForSubcontractDetailLoading = true;
				await PickingSupplyForSubcontractDetail.getList(this,filter,null,0,9999)
				.then((result)=>{
					this_.pickingSupplyForSubcontractDetails = result.data
					this_.isPickingSupplyForSubcontractDetailLoading = false;
				})
				.catch(error => { this_.isPickingSupplyForSubcontractDetailLoading = false; });
			}else{
				this.pickingSupplyForSubcontractDetails = [];
			}


			// PickingSupplyForSubcontractDetail.getList(this, filter, this.sortingByPickingSupplyForSubcontractDetail, currentPage , this.pickingSupplyForSubcontractDetailPageSize).then(result => {
			// 	this.currentPickingSupplyForSubcontractDetailPage = currentPage + 1;
			// 	this.pickingSupplyForSubcontractDetails = result.data.filter(obj =>
			// 		Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
			// 		);
			// 	this.pickingSupplyForSubcontractDetailsFiltered = result.data.filter(obj =>
			// 		Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
			// 		);
			// 	this.totalPickingSupplyForSubcontractDetailRow = result.dataCount;
			// }).catch(error => {});
		},
		// getPickingSupplyForSubcontracts : async function(input) {
		// 	let filter = new PickingSupplyForSubcontractFilter();
		// 	if (input != undefined) {
		// 		filter.PickingSupplyForSubcontractNumber = input;
		// 	}
		// 	this.isPickingSupplyForSubcontractComboLoading = true;
		// 	await PickingSupplyForSubcontract.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.pickingSupplyForSubcontracts = result.data
		// 		}
		// 		this.isPickingSupplyForSubcontractComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		// getPickingSupplyForSubcontracts : async function(input) {
		// 	let filter = new PickingSupplyForSubcontractFilter();
		// 	if (input != undefined) {
		// 		filter.pickingSupplyForSubcontractNumber = input;
		// 	}
		// 	this.isPickingSupplyForSubcontractComboLoading = true;
		// 	await PickingSupplyForSubcontract.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.pickingSupplyForSubcontracts = result.data
		// 		}
		// 		this.isPickingSupplyForSubcontractComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		getWorkOrderSupplySubContractDetails : async function(input) {
			let filter = new WorkOrderSupplySubContractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isWorkOrderSupplySubContractDetailComboLoading = true;
			await WorkOrderSupplySubContractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContractDetails = result.data
				}
				this.isWorkOrderSupplySubContractDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			await WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderSupplySubcontractExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.workOrderSupplySubcontractId = null;
				this.model.workOrderSupplySubcontract = null;
				this.isBusy = true;
				PickingSupplyForSubcontract.resetDocument(this, this.model.id).then(result => {
					this.getPickingSupplyForSubcontract(this.model.id).then(result => {
						this.getPickingSupplyForSubcontractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.workOrderSupplySubcontractId = item.id;
				this.model.workOrderSupplySubcontract = item;

				this.isBusy = true;
				PickingSupplyForSubcontract.copyFromDocument(this, 'workordersupplysubcontract', item.id, this.model.id).then(result => {
					this.getPickingSupplyForSubcontract(this.model.id).then(result => {
						this.getPickingSupplyForSubcontractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedWorkOrderSupplySubcontract(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.workOrderSupplySubcontractId == itemId) return;
			}

			if(this.pickingSupplyForSubcontractDetails != null && this.pickingSupplyForSubcontractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Picking Supply For Subcontract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedWorkOrderSupplySubcontractExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedWorkOrderSupplySubcontractExecuted(item);
			}
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingSupplyForSubcontractInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PickingSupplyForSubcontract.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PickingSupplyForSubcontract.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PickingSupplyForSubcontract.updateData(this, model, id)
					.catch((error) => {
						return this.getPickingSupplyForSubcontract(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getPickingSupplyForSubcontracts();
		},
		addRowDataPickingSupplyForSubcontractDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.pickingSupplyForSubcontractId =  this.modelId;
					PickingSupplyForSubcontractDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForSubcontractDetails(true);
						this.isShowPopupPickingSupplyForSubcontractDetail = false;
					})
				} else {
					model.pickingSupplyForSubcontractId =  this.modelId;
					PickingSupplyForSubcontractDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForSubcontractDetails(true);
						this.isShowPopupPickingSupplyForSubcontractDetail = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForSubcontractDetail(id) {
			this.pickingSupplyForSubcontractDetailId = id;
			this.isShowPopupPickingSupplyForSubcontractDetail = true; 
		},
		async deleteRowDataPickingSupplyForSubcontractDetail(id) {
			PickingSupplyForSubcontractDetail.deleteData(this, id).then(result => { this.getPickingSupplyForSubcontractDetails(); });
		},
		async resetDataPickingSupplyForSubcontractDetail() {
			this.pickingSupplyForSubcontractDetailId = "";
			this.isShowPopupPickingSupplyForSubcontractDetail = true;
		},
		async addDataPickingSupplyForSubcontractDetail() {
			PickingSupplyForSubcontractDetail.createData(this, { pickingSupplyForSubcontractId: this.modelId })
			.then(result => {
				this.getPickingSupplyForSubcontractDetails(true);
			})
		},
		async addFromClipboardPickingSupplyForSubcontractDetail() {
			let workOrderSupplyForSubconDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderSupplyForSubconDetails.push({ workOrderSupplyForSubconDetail: item, pickingSupplyForSubcontractId: this.modelId });
				});
				PickingSupplyForSubcontractDetail.addFromClipboard(this, workOrderSupplyForSubconDetails).then(result => { this.getPickingSupplyForSubcontractDetails() });
			});
		},
		async replaceFromClipboardPickingSupplyForSubcontractDetail() {
			let workOrderSupplyForSubconDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderSupplyForSubconDetails.push({ workOrderSupplyForSubconDetail: item, pickingSupplyForSubcontractId: this.modelId });
				});
				PickingSupplyForSubcontractDetail.replaceFromClipboard(this, workOrderSupplyForSubconDetails).then(result => { this.getPickingSupplyForSubcontractDetails() });
			});   
		},
		showPopupUploadPickingSupplyForSubcontractDetail() {
			this.isShowPopupUploadPickingSupplyForSubcontractDetail = true;
		},
		uploadDataPickingSupplyForSubcontractDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForSubcontractDetail = false; 
		},
		downloadPickingSupplyForSubcontractDetail(modalEvent) {
			this.isDownloadPickingSupplyForSubcontractDetail = true;
			this.filterPickingSupplyForSubcontractDetail.pickingSupplyForSubcontractId = this.modelId;
			PickingSupplyForSubcontractDetail.downloadDataDetail(this, this.filterPickingSupplyForSubcontractDetail).then(result => {
				this.isDownloadPickingSupplyForSubcontractDetail = false;
			}).catch(error => { this.isDownloadPickingSupplyForSubcontractDetail = false; })
		},
		saveInputPickingSupplyForSubcontractDetail(item) {
			if (this.pickingSupplyForSubcontracts != null && this.pickingSupplyForSubcontracts != undefined  && this.pickingSupplyForSubcontracts.length > 0) {
				item.pickingSupplyForSubcontract = this.pickingSupplyForSubcontracts.find(q => q.id == item.pickingSupplyForSubcontractId);
			}
			if (this.workOrderSupplySubContractDetails != null && this.workOrderSupplySubContractDetails != undefined  && this.workOrderSupplySubContractDetails.length > 0) {
				item.workOrderSupplyForSubconDetail = this.workOrderSupplySubContractDetails.find(q => q.id == item.workOrderSupplyForSubconDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.processBy = this.userInfos.find(q => q.id == item.processByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForSubcontractDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingSupplyForSubcontractDetail = false; 
			this.isShowPopupPickingSupplyForSubcontractDetail = false; 
			if (modalType == 'PickingSupplyForSubcontractDetail') {
				this.getPickingSupplyForSubcontractDetails();
			}
			this.workOrderSupplySubcontractQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		
		setModel(model){
			console.log('setModel =>',model)
			if (this.modelId!=model.id) {
				this.modelIdOld = this.modelId;
			}
			this.model = model;
			this.modelId = model.id;
			this.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractId =this.modelId;
		},
		getPickingSupplyForSubcontract : async function(id) {
			this.isBusy = true;
			await PickingSupplyForSubcontract.getData(this, id).then(result => {
				this.setModel(result);
				console.log('DeliveryQualityInspection',result);
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				console.log('result.workOrderSupplySubcontractId',result.workOrderSupplySubcontractId)
				console.log('result.workOrderSupplySubcontractId==null',result.workOrderSupplySubcontractId==null)
				if (result.workOrderSupplySubcontractId==null) {
					this.isBusy = false;
					this.goToNext(1);
					return;
				}
				if (this.model) {
					this.goToNext(2);
				}
				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		async goToRedirectScanWOS(){
			this.getPickingSupplyForSubcontracts();
			let this_ = this;
			await PickingSupplyForSubcontract.createData(this_).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'pickingsupplyforsubcontractscan';
						this_.$router.push({ name: createRoute, params : { id: result.id } });
						this_.getPickingSupplyForSubcontract(result.id);
					}
				}
			}).catch(error => {
			})
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async doFinishScan(){
			let this_ = this;
			this.PickingSupplyForSubcontractScannerObject.remarks = this.remarkInput;
			await PickingSupplyForSubcontractScanner.doRequest(this,'finishscan',this.PickingSupplyForSubcontractScannerObject)
			.then(async function(response){
				console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.remarkInput = '';
						
						this_.toast({message: 'Sukses Finish Picking Part !', title:'Sukses !', variant : 'success'});
						if (result.documentStatusId=='CLOSED') {
							this_.goToRedirectScanWOS();
							return;
						}
						this_.goToNext(2);
						return;
					}
				}
				this_.toast({message: 'Gagal Finish Scan ![1]', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				console.log(error)
				var stringError = 'Gagal Finish Scan ![2]';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			this.controlCardQrCode = '';
		},
		async finishScan() {
			
			let messageInfo = "Masih ada Remaining Qty yang perlu dipenuhi, apakah anda yakin untuk Finish Proses ini ?";

			if(this.modelDetail.remainingQty!=undefined && this.modelDetail.remainingQty!=null && this.modelDetail.remainingQty>0){
				if (this.remarkInput==""||this.remarkInput==null||this.remarkInput==undefined) {
					this.toast({message: 'Remarks harus diisi', title:'Error', variant : 'danger'});
					return null;
				}

				if(this.modelDetail.supplyQty == this.modelDetail.remainingQty)
					messageInfo = `Part ${this.modelDetail.partPartNumber} belum ada yang di Picking, sehingga tidak akan muncul pada Surat Jalan. Apakah anda yakin untuk melanjutkan?`;

				if(await this.showPopupWithMessage(messageInfo)){
					this.doFinishScan();
				}
			} else{
				this.doFinishScan();
			}
			
		},
		async scanControlCard() {
			let this_ = this;
			this.PickingSupplyForSubcontractScannerObject.controlCardNumber =  encodeURIComponent(this.controlCardQrCode);

			await PickingSupplyForSubcontractScanner.doRequest(this,'scancontrolcard',this.PickingSupplyForSubcontractScannerObject)
			.then(async function(response){
				console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {

						// //nanti go to next
						await this_.getPickingSupplyForSubcontractDetail(this_.modelDetail.id);
						this_.toast({message: 'Sukses Scan Control Card !', title:'Sukses !', variant : 'success'});
						return;
					}
				}
				this_.toast({message: 'Gagal Scan Control Card ![1]', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				console.log(error)
				var stringError = 'Gagal Scan Control Card ![2]';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			this.controlCardQrCode = '';
		},
		async scanWorkOrderSupplyPartSubcontract() {
			let this_ = this;
			this.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractDetailPartNumber =  encodeURIComponent(this.workOrderSupplySubcontractPartQrCode);

			await PickingSupplyForSubcontractScanner.doRequest(this,'scanmaterialissuepartnumber',this.PickingSupplyForSubcontractScannerObject)
			.then(async function(response){
				console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractDetailId = result.id;
						//nanti go to next
						await this_.getPickingSupplyForSubcontractDetail(result.id);
						this_.goToNext(3);
						return;
					}
				}
				this_.toast({message: 'Gagal Scan Material Issue Number ![1]', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				console.log(error)
				var stringError = 'Gagal Scan Material Issue Number ![2]';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			this.workOrderSupplySubcontractPartQrCode = '';
		},
		async scanWorkOrderSupplySubcontract() {
			let id = this.model.id;
			let this_ = this;
			this.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractNumber =  encodeURIComponent(this.workOrderSupplySubcontractQrCode);

			await PickingSupplyForSubcontractScanner.doRequest(this,'scanmaterialissuenumber',this.PickingSupplyForSubcontractScannerObject)
			.then(async function(response){
				console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.PickingSupplyForSubcontractScannerObject.pickingSupplyForSubcontractId = result.id;
						//nanti go to next
						await this_.getPickingSupplyForSubcontract(result.id);
						await this_.doRedirect();

						return;
					}
				}
				this_.toast({message: 'Gagal Scan Material Issue Number ![1]', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				console.log(error)
				var stringError = 'Gagal Scan Material Issue Number ![2]';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			this.workOrderSupplySubcontractQrCode = '';
		},
		
		async doRedirect(){
			let this_ = this;
			// console.log('doRedirect old id=>',this_.modelIdOld)
			// return;
			this.$router.replace('/pickingsupplyforsubcontract/scan/' + this.modelId, async() => {
				if (this_.modelIdOld) {
					// await PickingSupplyForSubcontract.deleteData(this_,this_.modelIdOld);
				}
				return;
				}
			);
		},
		checkIsWorkOrderSupplySubContractDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		goToNext(page) {
			if(page == 1) {
				this.scanPageIndex = page;
			}
			if(page == 2) {
				
				this.getPickingSupplyForSubcontractDetails();
				this.scanPageIndex = page;
				return;
			}

			if(page == 3) {
				this.scanPageIndex = page;
			}

			if(page == 4) {
				this.saveAction();
				return;
			}

		},
	},
	beforeMount() {
		this.filterPickingSupplyForSubcontract = new PickingSupplyForSubcontractFilter();
		this.filterPickingSupplyForSubcontractDetail = new PickingSupplyForSubcontractDetailFilter();
		//this.getPickingSupplyForSubcontracts();
		//this.getWorkOrderSupplySubContractDetails();
		//this.getParts();
		//this.getUserInfos();
		//this.getWorkOrderSupplySubContracts();
		//this.getDocumentStatuss();
	},
	async mounted(){
		this.getPickingSupplyForSubcontracts();
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getPickingSupplyForSubcontract(id);
		}
		this.$nextTick(() => {
			this.getWorkOrderSupplySubContracts();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		workOrderSupplySubcontractQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingSupplyForSubcontracts(newValue);
			} else {
				this.getPickingSupplyForSubcontracts();
			}
		},
		workOrderSupplySubcontractPartQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingSupplyForSubcontractDetails(newValue);
			} else {
				this.getPickingSupplyForSubcontractDetails();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
